import { render } from "./InputGroupPage.vue?vue&type=template&id=2f9df572"
import script from "./InputGroupPage.vue?vue&type=script&lang=js"
export * from "./InputGroupPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__